module.exports = __webpack_public_path__ + "img/cartao_elo.854a3c25.png";